import { graphql } from '@/generated/gql';

export const DEMAND_AWARD_NEGOTIATION_CASE = graphql(/* GraphQL */ `
  mutation DemandNegotiationCaseAward($id: UUID!, $data: TsrctDemandAwardInput!) {
    tesseract {
      demand(id: $id) {
        award(data: $data)
      }
    }
  }
`);
